import $ from "jquery";

function init() {
    $(".layoutNavLink").on("click", evtNavLinkClick);
}

function evtNavLinkClick() {
    //forms.showSpinner(false);
}

export const layout = {
    init: init
};